import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LogOutIcon, HelpCircleIcon, BellIcon, BookIcon } from 'lucide-react';
import { AuthContext } from '../../App';
import { Avatar } from '../ui/Avatar';
export function Header() {
  const {
    logout,
    userInfo
  } = useContext(AuthContext);
  return <header className="bg-gray-800 border-b border-gray-700 py-4 px-6 flex items-center justify-between sticky top-0 z-10" data-id="element-474">
      <div className="flex items-center" data-id="element-475">
        <h1 className="text-xl font-bold text-blue-300" data-id="element-476">Expense Tracker</h1>
      </div>
      <div className="flex items-center space-x-4" data-id="element-477">
        <Link to="/knowledge-base" className="p-2 text-gray-300 hover:text-gray-100 rounded-full hover:bg-gray-700 transition-colors flex items-center" data-id="element-478">
          <BookIcon size={20} data-id="element-479" />
        </Link>
        <button className="p-2 text-gray-300 hover:text-gray-100 rounded-full hover:bg-gray-700 transition-colors" data-id="element-480">
          <HelpCircleIcon size={20} data-id="element-481" />
        </button>
        <button className="p-2 text-gray-300 hover:text-gray-100 rounded-full hover:bg-gray-700 transition-colors relative" data-id="element-482">
          <BellIcon size={20} data-id="element-483" />
          <span className="absolute top-1 right-1 h-2 w-2 bg-red-500 rounded-full" data-id="element-484"></span>
        </button>
        <div className="h-8 w-px bg-gray-700 mx-2" data-id="element-485"></div>
        <div className="flex items-center" data-id="element-486">
          <Avatar name={userInfo.name} id={userInfo.id} size="sm" className="mr-2" data-id="element-487" />
          <span className="text-sm font-medium text-gray-200 mr-4" data-id="element-488">
            {userInfo.name}
          </span>
          <button onClick={() => logout()} className="text-gray-300 hover:text-gray-100 p-1 rounded-full hover:bg-gray-700 transition-colors" aria-label="Log out" data-id="element-489">
            <LogOutIcon size={20} data-id="element-490" />
          </button>
        </div>
      </div>
    </header>;
}